module.exports = __webpack_public_path__ + "static/media/logoFilled.746619af.svg";